<template>
  <span
    class="menu-button"
    :class="{ active: menuOpen}"
  >
    <button
      ref="menu-button"
      :class="[
        `button--${buttonStyle}`,
        `button--${buttonSize}` ]"
      class="button button--icon"
      :aria-label="'Menyknapp för ' + ariaLabel"
      @click.stop.prevent="toggleMenu"
    >
      <svgicon :name="icon" />
    </button>
    <div
      v-if="menuOpen"
      ref="menu-button-card"
      class="menu-button__menu-card"
      :class="[
        `size--${buttonSize}`,
        newPosition]"
      @click.stop.prevent=""
    >
      <slot :toggle="toggleMenu" />
    </div>
  </span>
</template>

<script>
import svgIcon from "vue-svgicon"
import "#/Controls/Close"
import "#/Controls/MoreHorizontal"

export default {
  name: "MenuButton",
  components: {
    svgicon: svgIcon
  },
  props: {
    buttonSize: {
      type: Number,
      default: 40,
      validator: value => [32, 40, 48, 56, 64].includes(value)
    },
    menuPosition: {
      type: String,
      default: "left"
    },
    ariaLabel: {
      type: String,
      default: "receptkort"
    },
    buttonStyle: {
      type: String,
      default: "white",
      validator (value) {
        return ["primary", "secondary", "white"].includes(value)
      }
    }
  },
  data: () => ({
    menuOpen: false,
    newPosition: ""
  }),
  computed: {
    icon () {
      if (this.menuOpen) {
        return "Controls/Close"
      } else {
        return "Controls/MoreHorizontal"
      }
    },
  },
  beforeDestroy () {
    document.removeEventListener("click", this.closeMenu)
  },
  mounted () {
    if(this.$root) {
      this.$root.$on('molecules-menu-button-open-event', () => {
        if(this.menuOpen) {this.closeMenu()}
      })
    }
  },
  methods: {
    setNewPosition () {
      this.$nextTick(() => {
        if (this.newPosition) {return}

        const elMenu = this.$refs["menu-button-card"]
        const elButton = this.$refs["menu-button"]
        if(!elMenu || !elButton) {
          this.newPosition = this.menuPosition
          return
        }

        const { width: menuWidth } = elMenu.getBoundingClientRect()
        const { right, width } = elButton.getBoundingClientRect()
        const windowWidth = (window.innerWidth || document.documentElement.clientWidth)
        const leftSideSpace = right - 8
        const rightSideSpace = windowWidth - (right - width + 8) 

        let newPosition = ''
        if((leftSideSpace < menuWidth && rightSideSpace < menuWidth) ||
            (leftSideSpace > menuWidth && rightSideSpace > menuWidth)) {
            // each side is either not enought, or enough, so use default 
            newPosition = this.menuPosition
          } else if (leftSideSpace > menuWidth && rightSideSpace < menuWidth) {
            newPosition = "left"
          } else if (rightSideSpace > menuWidth && leftSideSpace < menuWidth) {
            newPosition = "right"
          } else {
            newPosition = this.menuPosition
          }
          this.newPosition = newPosition
      })
    },
    toggleMenu () {
      !this.menuOpen && this.$root && this.$root.$emit('molecules-menu-button-open-event')

      this.menuOpen = !this.menuOpen
      if (this.menuOpen) {
        this.setNewPosition()
        document.addEventListener("click", this.closeMenu)
      } else {
        this.newPosition = ''
        this.removeListener()
      }
    },
    removeListener () {
      document.removeEventListener("click", this.closeMenu)
    },
    closeMenu (e) {
      if(e){
        e.preventDefault()
        e.stopPropagation()
      }
      this.menuOpen = false
      this.removeListener()
    }
  }
}
</script>

<style lang="scss">
.menu-button {
  position: absolute;
  z-index: 2;

  &.active {
    z-index: 10 !important;

    > button {
      background: $color-red-dark;
      color: $color-white;
      fill: $color-white;
      z-index: 4;
      right: 0;
    }
  }

  &__menu-card {
    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.12);
    position: absolute;
    background: $color-white;
    padding: 1.125rem 0.5rem;
    border-radius: 1rem;
    z-index: -1;
    top: 0.75rem;
    left: auto;
    right: 0.75rem;

    &.size--40 {
      top: 1rem;
      right: 1rem;
    }

    &.size--48 {
      top: 1.25rem;
      right: 1.25rem;
    }

    &.size--56 {
      top: 1.5rem;
      right: 1.5rem;
    }

    &.size--64 {
      top: 1.75rem;
      right: 1.75rem;
    }

    &.right {
      left: 0.75rem;
      right: auto;

      &.size--40 {
        top: 1rem;
        left: 1rem;
      }

      &.size--48 {
        top: 1.25rem;
        left: 1.25rem;
      }

      &.size--56 {
        top: 1.5rem;
        left: 1.5rem;
      }

      &.size--64 {
        top: 1.75rem;
        left: 1.75rem;
      }
    }
  }
}
</style>
